export const isProduction = () => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    return false;
  }
  /* istanbul ignore next */
  if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'test') {
    return false;
  }
  /* istanbul ignore next */
  return true;
};
